import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const loadingSpinner = css`
  margin-top: ${pxToRem(-2)};
`;
